import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import homeReducer from '../features/home/redux/reducer';
import commonReducer from '../features/common/redux/reducer';
import loginReducer from '../features/login/redux/reducer';
import errorReducer from '../features/error/redux/reducer';
import systemReducer from '../features/system/redux/reducer';
import generateReducer from '../features/generate/redux/reducer';
import adminReducer from '../features/admin/redux/reducer';
import fileReducer from '../features/file/redux/reducer';
import roleReducer from '../features/role/redux/reducer';
import formeditReducer from '../features/formedit/redux/reducer';
import systemconfigReducer from '../features/systemconfig/redux/reducer';
import alogReducer from '../features/alog/redux/reducer';
import furuiReducer from '../features/furui/redux/reducer';
// import testReducer from '../features/test/redux/reducer';
import userReducer from '../features/user/redux/reducer';
import planReducer from '../features/plan/redux/reducer';
import productReducer from '../features/product/redux/reducer';
import gkproductReducer from '../features/gkproduct/redux/reducer';

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage them.

const reducerMap = {
  router: routerReducer,
  home: homeReducer,
  common: commonReducer,
  login: loginReducer,
  error: errorReducer,
  system: systemReducer,
  generate: generateReducer,
  admin: adminReducer,
  file: fileReducer,
  role: roleReducer,
  formedit: formeditReducer,
  systemconfig: systemconfigReducer,
  alog: alogReducer,
  furui: furuiReducer,
  // test: testReducer,
  user: userReducer,
  plan: planReducer,
  product: productReducer,
  gkproduct: gkproductReducer,
};

export default combineReducers(reducerMap);



// WEBPACK FOOTER //
// ./src/common/rootReducer.js